// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__ij8bb","bannerRichText":"styles_bannerRichText__Y90fU"};